import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	min-height: 260px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
	padding: 20px;
	background-size: cover;
	flex-direction: column;
	gap: 17px;
`;

export const NumberWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-size: cover;
	color: white;
	font-weight: 900;
	font-size: 91px;
	width: 162px;
	height: 92px;
`;

export const Title = styled.p`
	font-weight: 900;
	font-size: 50px;
	line-height: 56px;
	text-align: center;
	text-transform: uppercase;
	color: #ffffff;

	@at-root html[lang='en'] & {
		max-width: 268px;
	}

	@media (max-width: 350px) {
		font-size: 40px;
	}
`;
